import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import Container from '../../components/Container';
import Button from '../../components/Button';
import Loader from '../../components/Loader';
import Header from '../../components/Header';
import EventDetailsSideBar from '../RepVisitsCalendarEventDetailsSideBar';
import Event from '../../components/RequestNotification';
import Notification from '../../components/ActivityNotification';
import NotificationsRequestsNoResults from '../../components/RequestNotification/empty';
import SidebarWrapper from '../../components/SidebarWrapper';
import PageTitle from '../../components/PageTitle';
import messages from './messages';
import { messages as notificationMessages } from '../../components/RepVisitsNotificationsFrame';
import './styles.css';

class RepVisitsNotificationsRequestsVirtual extends React.PureComponent {
  static propTypes = {
    visible: PropTypes.bool,
    displaySidebarComponent: PropTypes.func,
    closeSidebar: PropTypes.func,
    showSideBar: PropTypes.func,
    viewer: PropTypes.object,
    refetch: PropTypes.func.isRequired,
    loadMore: PropTypes.func.isRequired,
    dismissNotification: PropTypes.func.isRequired,
  };

  static getDerivedStateFromProps(props, state) {
    const events = props.viewer.repVisitsEvents.slice(0, state.currentTotal);
    const notifications = props.viewer.repVisitsNotifications.edges.map((edge) => edge.node);
    const hasMoreEvents = props.viewer.repVisitsEvents.length > events.length;
    const hasMoreNotifications = props.viewer.repVisitsNotifications.pageInfo.hasNextPage;
    const hasNextPage = hasMoreEvents || hasMoreNotifications;
    const eventsAndNotifications = [
      ...events.map((event) => ({ ...event, isEvent: true })),
      ...notifications.map((event) => ({ ...event, isNotification: true })),
    ].sort((e1, e2) =>
      (parseInt(e2.dateRegistered, 10) || parseInt(e2.date, 10)) -
      (parseInt(e1.dateRegistered, 10) || parseInt(e1.date, 10)));
    return { events, notifications, eventsAndNotifications, hasNextPage };
  }

  state = {
    currentTotal: 25,
    notification: null,
    loading: false,
  };

  removeNotification = () => {
    this.setState({ notification: null });
  };

  onSave = (notification) => {
    this.setState({ notification: notification && React.cloneElement(notification, { onDeactivate: this.removeNotification }) });
    this.props.closeSidebar();
  };

  loadMore = () => {
    this.setState((prevState) => ({ currentTotal: prevState.currentTotal + 25 }));
    this.props.loadMore('viewer.repVisitsNotifications').then(() => this.setState({ loading: false }));
  };

  dismissNotification = (notificationId) => this.props.dismissNotification({
    variables: {
      input: {
        id: notificationId,
      },
    },
  }).then(() => this.props.refetch());

  showSideBar = (eventOrNotification, onlyVisitUrl, notificationId) => {
    const highSchoolId = get(eventOrNotification, 'highSchool.id');
    const event = eventOrNotification.event || eventOrNotification;
    const schoolIdParam = { id: highSchoolId };
    this.props.displaySidebarComponent(
      <SidebarWrapper.Bar>
        <EventDetailsSideBar
          visible
          onSave={this.onSave}
          event={event}
          params={schoolIdParam}
          onlyVisitUrl={onlyVisitUrl}
          notificationId={notificationId}
          dismissNotification={this.dismissNotification}
        />
      </SidebarWrapper.Bar>,
    );
  };

  renderContent = () => {
    const { eventsAndNotifications, hasNextPage } = this.state;
    return (
      <div styleName="request-content">
        {this.state.notification}
        {eventsAndNotifications.map((element) => (element.isEvent ?
          (
            <Event
              key={element.id}
              repVisitsEvent={element}
              showSideBar={this.showSideBar}
            />
          ) :
          (
            <Notification
              key={element.id}
              notification={element}
              currentUserId={this.props.viewer.uuid}
              displaySidebarComponent={this.showSideBar}
              dismissNotification={this.dismissNotification}
            />
          )))}
        {hasNextPage && (
          <Container textAlign="center" styleName="load-more-container">
            <Loader inline active={this.state.loading} />
            <Button basic size="small" id="show-more-link" onClick={this.loadMore}>
              <FormattedMessage {...messages.requestsShowMore} />
            </Button>
          </Container>
        )}
      </div>
    );
  }

  render() {
    const { eventsAndNotifications } = this.state;
    return (
      <div styleName="request-content">
        <PageTitle subTitle="Requests" title="RepVisits Notifications" category="Intersect" />
        <Header as="h2" styleName="section-title" id="right-side-heading">
          <FormattedMessage {...notificationMessages.requests} />
        </Header>
        {!eventsAndNotifications.length && <NotificationsRequestsNoResults />}
        {!!eventsAndNotifications.length && this.renderContent()}
      </div>
    );
  }
}

export default RepVisitsNotificationsRequestsVirtual;
